
export default class Stripe {

  static BASE_URL = 'https://connect.stripe.com/express/oauth/authorize'

  // Initialize Stripe
  static setupAccount(userId) {
    const clientId = process.env.REACT_APP_STRIPE_CLIENT_ID
    const redirectURI = process.env.REACT_APP_STRIPE_REDIRECT_URI
    const securityToken = userId
    const params = '?redirect_uri=' + redirectURI + '&client_id=' + clientId + '&state=' + securityToken
    window.location.href = this.BASE_URL + params
  }

}